export const clientPrototypeConfig = {
  defaultUserId: "prototype-user",
  defaultUserEmail: "prototype@deepmox.local",
  defaultSubscriptionId: "prototype-subscription",
  developmentTurnstileToken: "prototype-dev-token",
} as const;
